import ViewTicketType from "./ViewTicketType";

export default ViewTicketType